import React from 'react'

const PulseSurveyTab = () => {
    return (
        <div>
            
        </div>
    )
}

export default PulseSurveyTab